import { useState, useEffect, Fragment, useRef } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import AppContext from "../../AppContext";
import MenuTable from "../../helpers/MenuTable";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import SortBy from "../../helpers/SortBy";
import InputCombo from "../../helpers/InputCombo";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputDecimal from "../../helpers/InputDecimal";
import CalculateReview from "./CalculateReview";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Csv from "../../exporter/Csv";
import Xlsx from "../../exporter/Xlsx";
import Print from "../../exporter/Print";
import InputDate from "../../helpers/InputDate";
import NotsForm from "./NotsForm";



function Nots(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


 var defId = -1;
    if(props.fak_kontrahenci_id != undefined) defId = props.fak_kontrahenci_id;

    const [clientsCombo, setClientsCombo] = useState(null);
    const [selectedId, setSelectedId ] = useState(defId);

       const tabRef = useRef(0); //do druku
        const tab2Ref = useRef(0);
 

    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({   


        fak_kontrahenci_id:  defId,   
       
        nazwa:  props.mainView.readFilter('nt_nazwa',''),    
        numer:  props.mainView.readFilter('nt_numer',''),   

        do_zaplaty_od:  props.mainView.readFilter('nt_do_zaplaty_od',''),   
        do_zaplaty_do:  props.mainView.readFilter('nt_do_zaplaty_do',''),   

        kwota_rozliczenia_od:  props.mainView.readFilter('nt_kwota_rozliczenia_od',''),   
        kwota_rozliczenia_do:  props.mainView.readFilter('nt_kwota_rozliczenia_do',''),   

        rozliczono:  props.mainView.readFilter('nt_rozliczono','_x_'),   
        data_wystawienia_od:  props.mainView.readFilter('nt_data_wystawienia_od',''),   
        data_wystawienia_do:  props.mainView.readFilter('nt_data_wystawienia_do',''),   

 
      
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);


    const [selectedRow, setSelectedRow] = useState([]);

    const [view, setView] = useState ( "list");

    const [legend, setLegend] = useState([ 
         {
            cls:'color_show5',
            title: 'dokument opłacony',
           filter: {  filed: "status_rozliczenia", set: "1", typ: "combo"  },
        },       
        {
            cls:'color_deleted',
            title: 'pozycja nierozliczona',
             filter: {  filed: "rozliczono", set: "0", typ: "combo"  },
        },
    ]);



         const listenerSelectedId = (filedName, val, correct, msg) => 
        {
            setSelectedId(val);
        }


           const changeDateX = (h) => {

            function getDaysInMonth(m, y) {
                   return m===2 ? y & 3 || !(y%25) && y & 15 ? 28 : 29 : 30 + (m+(m>>3)&1);
            }

            var t = h.target.getAttribute('atr-dt');
             
            if(t == '-m')
            {
                let dt = new Date( new Date().setMonth(new Date().getMonth() - 1) );                

                var last = getDaysInMonth( dt.getMonth()+1, dt.getFullYear()  );

                console.log('Date', dt,  dt.getMonth()+1, dt.getFullYear()  );
            
                dt = dt.toLocaleDateString('en-CA');
                dt = "" + dt.substring(0,7) + "-01";
                last  = "" + dt.substring(0,7) + "-" + last;
                console.log(dt, last);

                setFilterParam( {...filterParam, ["data_wystawienia_od"]:dt,  ["data_wystawienia_od_valid"]:true, ["data_wystawienia_do"]:last,  ["data_wystawienia_do_valid"]:true,     } );                   
 
            }

            if(t == '+m')
            {
                let dt = new Date( new Date().setMonth(new Date().getMonth() + 1) );
                //console.log('Date', dt);

                var last = getDaysInMonth( dt.getMonth()+1, dt.getFullYear()  );

                console.log('Date', dt,  dt.getMonth()+1, dt.getFullYear()  );

                dt = dt.toLocaleDateString('en-CA');
                dt = "" + dt.substring(0,7) + "-01";
                last  = "" + dt.substring(0,7) + "-" + last;
                console.log(dt, last);

                setFilterParam( {...filterParam, ["data_wystawienia_od"]:dt,  ["data_wystawienia_od_valid"]:true, ["data_wystawienia_do"]:last,  ["data_wystawienia_do_valid"]:true,     } ); 
            }

            //var dt = new Date();
            //dt = dt.toLocaleDateString('en-CA');
            //dt = "" + dt.substring(0,7) + "-01";


                    var defTimeOut = 5000;            
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );

        }

        const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );                                  
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 500;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
        
            props.mainView.writeFilter(filedName, val);            
        }



             const goNextNew = () => {
            console.log("goNext");    
            setTab(null);    
        }      

        const filterClear = () => {

            var defId = -1;
            if(props.fak_kontrahenci_id != undefined) defId = props.fak_kontrahenci_id;

            props.mainView.writeFilter('nt_nazwa', ''); 
            props.mainView.writeFilter('nt_numer', '');

            props.mainView.writeFilter('nt_do_zaplaty_od', '');
            props.mainView.writeFilter('nt_do_zaplaty_do', '');

            props.mainView.writeFilter('nt_kwota_rozliczenia_od', '');
            props.mainView.writeFilter('nt_kwota_rozliczenia_do', '');

            props.mainView.writeFilter('nt_rozliczono', '_x_');
            props.mainView.writeFilter('nt_data_wystawienia_od', '');
            props.mainView.writeFilter('nt_data_wystawienia_do', '');
          
           
            setFilterParam({

                fak_kontrahenci_id: defId,
                nazwa: '',                                        
                numer: '',                 
                do_zaplaty_od: '',                 
                do_zaplaty_do: '',                 
                kwota_rozliczenia_od: '',                 
                kwota_rozliczenia_do: '',                 
                rozliczono: '_x_',                 
                data_wystawienia_od: '',                 
                data_wystawienia_do: '',                 
              
                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },

                limit: 50,
                page: 1,
                show: true,
            });
            setTab(null);
        }

        const filterApprove = () => {   
            setTab(null)     
        }




        

        const onChangePagger = (x_limit, x_page) => {

            setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
            setTab(null);
        }

        const onChangeSortBy = (sortBy) => {

            setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
            setTab(null);
        }




    const getTab = () => {
        
      
       props.mainView.showProgress();

        fetch( Config.url + '/rest_v1_calc,nots', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server.." , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setTab(res.result);             
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }


    const removeDoc = (e) => {

        var title = e.target.getAttribute('atr-title');
        var id = e.target.getAttribute('atr-id');

        props.mainView.showDialog( "Potwierdź", "Czy na pewno chcesz usunąć dokument ("+title+")" , "yesno" ,  (res)=>{

                    if(res == "yes")
                    {
                                //---------------------------------------------------------------------
                                //---------------------------------------------------------------------
                        

                                 props.mainView.showProgress();       
                    

                                    fetch( Config.url + '/rest_v1_calc,not_remove', {
                                        method: 'POST', 
                                        body: JSON.stringify({
                                            id: id,
                                        }), 
                                        headers: {
                                            'Content-Type': 'application/json',                    
                                            'X-Api-Key': props.userData.apiKey,
                                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                            '_sec_key_': Config.genXKey() ,
                                        }
                                    })
                                    .then(res => res.json() )
                                    .then(res => { 

                                            props.mainView.hideProgress();    

                                                if(res._sys_ == undefined)
                                                {
                                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                }else
                                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                {
                                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                }else    
                                                {
                                                    if(res.status == 'OK')         
                                                    {       
                                                        setTab(null);//pobierz na nowo        
                                                        props.mainView.showDialog( "Sukces", "Dokument został usunięty"  , "ok" , null);                             
                                                    }else 
                                                    {
                                                        props.mainView.showDialog( "Ups!", "Nie można usunać dokumentu " + res.result , "error" , null);
                                                    }
                                                }
                                    } )
                                    .catch(err => {          
                                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                            props.mainView.hideProgress();    
                                    });

                                //---------------------------------------------------------------------
                                //---------------------------------------------------------------------
                    }


        } );


    }
 

    
//-------------------------------------------------------
//-------------------------------------------------------
//MASS
const changeSelected = (e) => {

    var id    = e.target.getAttribute('atr-id');   
    var selected = 0;

    if(e.target.checked) selected = 1;

    for(var k=0; k<selectedRow.length; k++)
    {
        if(selectedRow[k].id == id)  selectedRow[k].selected = selected;
    }

    setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) );    
}

const changeSelectedAll = (e) => {

    var s = selectedRow[0].selected;
    if(s == 1) {  s = 0; } else s = 1;

    for(var k=0; k<selectedRow.length; k++)
        {
          selectedRow[k].selected = s;
        }
    
        setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) ); 

}





//-------------------------------------------------------
//-------------------------------------------------------

   const goDownload = (e) => {

         var id = e.target.getAttribute('atr-id');
         var title = e.target.getAttribute('atr-title');

         var fileName = title.replace(/[/]/g,"_") + ".pdf";

         var links = [
            {
                link: '/rest_v1_calc,not_pdf',
                typ: 'pdf',
                fileName:  fileName,
                params: {
                    id: id
                },
            }
         ];

         if(Config.env == 'dev') console.log("goDownload", id, title);
         props.mainView.downloadDialog(links);
    }

    

    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });               
    }

   
   const onSuccess = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        getTab();
    }



       const keyListener = (e) => {


                        var code = e.keyCode ? e.keyCode : e.which;    

                        if(  code == 27 && (view.v == "assign"  || view.v == "new") )  
                        {
                                setView({v:'list',id:-1});
                        }else                                                     
                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                            e.target.blur();
                            filterClear();
                        }   else                        
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {
                           filterClear();
                        } else                                                                                          
                        if( e.target.nodeName.toLowerCase() == "body" && code === 37 && filterParam.page > 1)  //left
                        {
                            setFilterParam( {...filterParam,   ['page']: filterParam.page-1  } );  
                            setTab(null);
                        }else                                             
                        if(e.target.nodeName.toLowerCase() == "body" && code === 39 && filterParam.page < filterParam.pages)  //right
                        {
                            setFilterParam( {...filterParam,   ['page']: filterParam.page+1  } );  
                            setTab(null);
                        } else                                                                  
                        if (e.target.nodeName.toLowerCase() == "body" && code === 107) { //add +
                            setView({...view, ["v"]:'new', ["id"]:'-1' });
                        }else 
                        {
                               props.keyListener(e);
                        }

    }


   useEffect( ()=>{

            if(Config.env == "dev") console.log("Nots.js, listener on");
            window.onkeydown = keyListener;   
                    
            
            return () => {   
                 if(Config.env == "dev") console.log("Nots.js, listener off");             
                 window.onkeydown = props.keyListener;
            };

    } );


    

 

    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        filterClear();
        setTab(null);       
    }



      if(tab == null)
    {
        setTab([]);
        getTab();         
        return <div>
            ...
        </div>
    }


    //------------------------------------

    //sprawdzy czy utworzyc noty na podstawie koszyka..

    if(props.mainView.idSelected == 'create_from_trash' && props.mainView.vars.trash.length > 0)
    {
        var trash = JSON.parse( JSON.stringify( props.mainView.vars.trash ) );
        props.mainView.clearTrash();

      
        console.log("Trash", trash);

        props.mainView.showProgress();

        fetch( Config.url + '/rest_v1_calc,nots_create_from_trash', {
            method: 'POST', 
            body: JSON.stringify( {trash: trash} ), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();          


                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server.." , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        getTab();

                        if( parseInt(res.result) > 0 )
                        {
                              props.mainView.showDialog( "Sukces", "Utworzono not w liczbie: " + res.result , "ok" , null);  
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                  
    }

    //------------------------------------

    
    if(view.v == "review")
    {
 
        return <NotsForm  userData={props.userData} mainView={props.mainView} keyListener={keyListener} onBack={onBack}  onSuccess={onSuccess}  fak_kontrahenci_id={props.fak_kontrahenci_id}  id={view.id}  goDownload={goDownload} />
    }


    
    if(view.v == "calc")
    {
 
        return <CalculateReview  userData={props.userData} mainView={props.mainView} keyListener={keyListener} onBack={onBack}  onSuccess={onSuccess}  fak_kontrahenci_id={props.fak_kontrahenci_id}  id={view.id}   />
    }

    //------------------------------------



       var sortList = [                
        {column: "created_at", name: "Data utworzenia"  },         
        {column: "data_wystawienia", name: "Data wystawienia"  },         
        {column: "do_zaplaty", name: "Do zapłaty"  },         
        {column: "kwota_rozliczenia", name: "Kwota rozliczenia"  },         
        {column: "firma_nazwa", name: "Nazwa firmy"  },
        ]

        
 

    var titleRaport = " Noty obciążeniowe ";

    if(filterParam.nazwa.length > 2)
    {
        titleRaport = filterParam.nazwa + ", " + titleRaport;
    }

 

    var sumDoZaplaty = 0.0;
    var sumKwRozliczenia = 0.0;

    for(var k= 0 ;  k < tab.length; k++)
    {
        sumDoZaplaty =  parseFloat(sumDoZaplaty) + parseFloat( tab[k].do_zaplaty);
        sumKwRozliczenia =  parseFloat(sumKwRozliczenia) + parseFloat( tab[k].kwota_rozliczenia);
    }




    return  <div className="view_content">      
               <h3 className="dash_header">Noty obciążeniowe</h3>
       


               <div className="table_filter">

                        {
                            filterParam.fak_kontrahenci_id < 1 &&
                            <div className="filter_controll">   
                                                <label>Klient: </label>                             
                                                <InputText   userData={props.userData} value={filterParam.nazwa}   valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa: "}   />
                            </div> 
                        }                         

                         <div className="filter_controll">   
                                            <label>Numer dokumentu: </label>                             
                                            <InputText   userData={props.userData} value={filterParam.numer}   valChange={valChangeListener} goNext={goNextNew} name="numer" placeholder={"Opis: "}   />
                        </div>  



                        <div className="filter_controll filter_merge">   
                                <label>Data wystawienia (od dnia / do dnia): &nbsp; <sup className="link_color" atr-dt="-m" onClick={changeDateX} >[-m]</sup>  &nbsp; <sup className="link_color" atr-dt="+m" onClick={changeDateX} >[+m]</sup>   </label>      <br/>                       
                                <InputDate   userData={props.userData} value={filterParam.data_wystawienia_od}   valChange={valChangeListener} goNext={goNextNew} name="data_wystawienia_od" placeholder={"Od dnia: "}   />                                                                  
                                <InputDate   userData={props.userData} value={filterParam.data_wystawienia_do}   valChange={valChangeListener} goNext={goNextNew} name="data_wystawienia_do" placeholder={"Do dnia: "}   />
                        </div> 

                        
                        <div className="filter_controll filter_merge">   
                            <label>Kwota (od / do): </label>        
                            <br/>                     
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.do_zaplaty_od}   valChange={valChangeListener} goNext={goNextNew} name="do_zaplaty_od" placeholder={" "}   />
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.do_zaplaty_do}   valChange={valChangeListener} goNext={goNextNew} name="do_zaplaty_do" placeholder={" "}   />
                        </div>
 
                    <div className="filter_controll filter_merge">   
                            <label>Kwota rozliczenia (od / do): </label>        
                            <br/>                     
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_rozliczenia_od}   valChange={valChangeListener} goNext={goNextNew} name="kwota_rozliczenia_od" placeholder={" "}   />
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_rozliczenia_do}   valChange={valChangeListener} goNext={goNextNew} name="kwota_rozliczenia_do" placeholder={" "}   />
                        </div>


                        <div className="filter_controll">   
                                            <label>Rozliczono: </label>                             
                                            <InputCombo items={ [  {v:'_x_', title: '- - - '},  {v:'0', title: 'Nie'} ,  {v:'1', title: 'Tak'} ] }  userData={props.userData} value={filterParam.rozliczono}   valChange={valChangeListener} goNext={goNextNew} name="rozliczono" placeholder={": "}   />
                        </div>  
                        

                        <div className="filter_btn">                       
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść [esc]</span>
                        </div> 
               </div>

                <div className="table_widget">
                              <div className="btn gohide" onClick={changeView} v="new" id="-1"  > Wystaw notę [+]</div>

                              
                              <InputPagger filter={filterParam}  onChange={onChangePagger}  /> 
                                
                              <InputLegend items={legend}  valChange={valChangeListener} />

                              <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  


                                  &nbsp; &nbsp;
                                    <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={titleRaport} />   
                                    <Csv tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Xlsx tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Print tabRef={tab2Ref}   title={titleRaport} />

                </div>


                <div className="bg_center">


                         <div ref={tabRef} className="gohide">
                                    <h3>{titleRaport}</h3>  

                                     <table className="table" ref={tab2Ref} >

                                        <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                
                                                <td>Numer</td>                                                                                                                                    
                                                <td>Data</td>                                                                                                                                                                                                                                                                                                  
                                                <td>Klient</td>                                                                                                                                                                                                                                                                                                  
                                                <td>Termin płatności</td>                                                                                                                                    
                                                <td>Razem uznań</td>                                                                                                                                    
                                                <td>Razem obciążeń</td>                                                                                                                                     
                                                <td>Do zapłaty</td>                                                                                                                                    
                                                <td>Kw. rozliczenia</td>                                                                                                                                      
                                                <td >Wys. e-mail</td> 
                                                <td className="td_right">Wys. sms</td>                                                                                                                                      
                                                                                                                
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (item, ix) => {

                                                        var rowStyle = " row ";
                                                        if(ix % 2 == 0 )rowStyle = " row2 ";

                                                         if(item.zatwierdzona == "1" && item.do_zaplaty == item.kwota_rozliczenia ) rowStyle =  " color_show5 ";    

                                                        


                                                        return <tr className={rowStyle} key={ix}>                                                                                             
                                                            <td className="gocenter">{ix+1}</td>                                                             
                                                            <td>{item.numer_noty}</td>                                                                                                                                    
                                                            <td className="gocenter">{item.data_wystawienia}</td>                                                                                                                                                                                                                                                                                                  
                                                            <td className="goleft">{item.klient.nazwa}</td>                                                                                                                                                                                                                                                                                                  
                                                            <td className="gocenter">{item.termin_platnosci}</td>                                                                                                                                    
                                                            <td className="goright"><FormatDecimal value={item.razem_uznan}/></td>                                                                                                                                    
                                                            <td className="goright"><FormatDecimal value={item.razem_obciazen}/></td>                                                                                                                                     
                                                            <td className="goright"><FormatDecimal value={item.do_zaplaty}/></td>                                                                                                                                    
                                                            <td className="goright"><FormatDecimal value={item.kwota_rozliczenia}/></td>                                                                                                                                      
                                                            <td className="gocenter" >
                                                                {
                                                                    item.wys_powiadomienie_email == 1 &&
                                                                    <span>Tak</span>
                                                                }
                                                                 {
                                                                    item.wys_powiadomienie_email == 0 &&
                                                                    <span>Nie</span>
                                                                }
                                                            </td> 
                                                            <td className="gocenter">
                                                                {
                                                                    item.wys_powiadomienie_sms == 1 &&
                                                                    <span>Tak</span>
                                                                }
                                                                 {
                                                                    item.wys_powiadomienie_sms == 0 &&
                                                                    <span>Nie</span>
                                                                }
                                                            </td>                                                                                                                                                                                                                                                                              
                                                        </tr>

                                                    } )
                                                }

                                        </tbody>

                            </table>
                        </div>


                            <table className="table"  >

                                        <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>
                                        
                                                <td>Numer</td>                                                                                                                                    
                                                <td>Data</td>                                                                                                                                                                                                                                                                                                  
                                                <td>Klient</td>                                                                                                                                                                                                                                                                                                  
                                                <td>Termin płatności</td>                                                                                                                                    
                                                <td>Razem uznań</td>                                                                                                                                    
                                                <td>Razem obciążeń</td>                                                                                                                                     
                                                <td>Do zapłaty</td>                                                                                                                                    
                                                <td>Kw. rozliczenia</td>                                                                                                                                      
                                                <td >Wys. e-mail</td> 
                                                <td className="td_right">Wys. sms</td>                                                                                                                                      
                                                <td className="td_option"></td>                                                                                  
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (item, ix) => {

                                                        var rowStyle = " row ";
                                                        if(ix % 2 == 0 )rowStyle = " row2 ";

                                                         if(item.zatwierdzona == "1" && item.do_zaplaty == item.kwota_rozliczenia ) rowStyle =  " color_show5 ";    

                                                           var isChecked = "";

                                                            for(var s=0; s<selectedRow.length; s++)
                                                                {
                                                                    if( selectedRow[s].id == item.id &&  selectedRow[s].selected == 1) isChecked = "checked";
                                                                }


                                                        return <tr className={rowStyle} key={ix}>                                                                                             
                                                            <td className="gocenter" v="review" id={item.id} onClick={changeView}>{ix+1}</td>
                                                      
                                                            <td v="review" id={item.id} onClick={changeView}>{item.numer_noty}</td>                                                                                                                                    
                                                            <td className="gocenter" v="review" id={item.id} onClick={changeView}>{item.data_wystawienia}</td>                                                                                                                                                                                                                                                                                                  
                                                            <td className="goleft" v="review" id={item.id} onClick={changeView}>{item.klient.nazwa}</td>                                                                                                                                                                                                                                                                                                  
                                                            <td className="gocenter">{item.termin_platnosci}</td>                                                                                                                                    
                                                            <td className="goright"><FormatDecimal value={item.razem_uznan}/></td>                                                                                                                                    
                                                            <td className="goright"><FormatDecimal value={item.razem_obciazen}/></td>                                                                                                                                     
                                                            <td className="goright"><FormatDecimal value={item.do_zaplaty}/></td>                                                                                                                                    
                                                            <td className="goright"><FormatDecimal value={item.kwota_rozliczenia}/>  
                                                                    {
                                                                        item._saldo_ != undefined &&
                                                                        <sup className="link_color" v="calc" id={item._saldo_.id} onClick={changeView} >&nbsp;[r]&nbsp;</sup>
                                                                    } </td>                                                                                                                                      
                                                            <td className="gocenter" >
                                                                {
                                                                    item.wys_powiadomienie_email == 1 &&
                                                                    <span>Tak</span>
                                                                }
                                                                 {
                                                                    item.wys_powiadomienie_email == 0 &&
                                                                    <span>Nie</span>
                                                                }
                                                            </td> 
                                                            <td className="gocenter">
                                                                {
                                                                    item.wys_powiadomienie_sms == 1 &&
                                                                    <span>Tak</span>
                                                                }
                                                                 {
                                                                    item.wys_powiadomienie_sms == 0 &&
                                                                    <span>Nie</span>
                                                                }
                                                            </td>                                                                                                                                      
                                                             <MenuTable>
                                                                    <ul>
                                                                        {
                                                                            item.zatwierdzona == '0' &&
                                                                            <li   onClick={ removeDoc } atr-id ={ item.id } atr-title ={ item.numer_noty }  > Usuń </li>
                                                                        }            
                                                                        {
                                                                            item.zatwierdzona == 1  &&
                                                                            <Fragment>
                                                                                <li   onClick={ goDownload } atr-id ={ item.id } atr-title ={ item.numer_noty }  > Pobierz </li>                                                                     
                                                                            </Fragment>                                                                           
                                                                        }                                                                                                                                   
                                                                        <li v="review" id={item.id} onClick={changeView}>Szczegóły</li>                                                                   
                                                                    </ul>
                                                                </MenuTable>                                                                               
                                                        </tr>

                                                    } )
                                                }



                                                <tr className="">                                                                                               
                                                <td className="td_left"></td>
                                        
                                                <td></td>                                                                                                                                    
                                                <td></td>                                                                                                                                                                                                                                                                                                  
                                                <td></td>                                                                                                                                                                                                                                                                                                  
                                                <td></td>                                                                                                                                    
                                                <td></td>                                                                                                                                    
                                                <td></td>                                                                                                                                     
                                                <td className="gobold goright"><FormatDecimal value={sumDoZaplaty}/> </td>                                                                                                                                    
                                                <td className="gobold goright"><FormatDecimal value={sumKwRozliczenia}/></td>                                                                                                                                      
                                                <td ></td> 
                                                <td className="td_right"></td>                                                                                                                                      
                                                <td className="td_option"></td>                                                                                  
                                            </tr>
                                            

                                        </tbody>

                            </table>

                </div>

    </div>
}

export default Nots;